import { AxiosAdapter } from '../../../_config/adapters/axios/axios.adapter';
import { Http } from '../../../_config/adapters/axios/axios.protocols';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export class Service {
	async getAll(page, name_local, pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/country/${Enviroment.LANGUAGE}/page/${page}`,
			params: { name_local, pharmacy },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getById(id) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/${id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getPharmacies() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FRONT_COMMON}/pharmacies/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}

	async getByNameLocal(nameLocal, page) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/name-local/${nameLocal}/page/${page}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async create(body) {
		return new AxiosAdapter({
			method: Http.POST,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async updateById(id, body) {
		return new AxiosAdapter({
			method: Http.PUT,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/${id}`,
			data: body,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async deleteById(id) {
		return new AxiosAdapter({
			method: Http.DELETE,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/${id}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getBrandsByCountry() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/pharmacy-locals/brand/country/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getRegionsByCountry() {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/place/country/${Enviroment.LANGUAGE}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getCommunesByRegion(region) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.FUNCTION_MIGRATION_PHAROL}/place/country/${Enviroment.LANGUAGE}/region/${region}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}

	async getPharmacieMP(pharmacy) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.MERCADO_PAGO_AR}/token-pharmacy/${pharmacy}`,
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				throw e;
			});
	}
}
